module.exports = __webpack_public_path__ + "static/d8_certification-e67550df5722bdc067ab74c5931820a6.png";